import React from 'react';
import { Card, CardContent, Typography, CardActions, Button, Grid } from '@mui/material';
import { format } from 'date-fns'

const EventCard = ({ event, handleRegister }) => {
return (
        <Card sx={{ minWidth: 200 }}>
                <CardContent>
                    <Grid container spacing={1}>
                    <Grid item md={12}>
                    <Typography variant="h6" component="div">
                            {event.name}
                        </Typography>
                        </Grid>
                        <Grid item md={12}>
                        <Typography variant="body2" color="textSecondary">
                            {format(new Date(event.date), 'MMM dd, yyyy hh:mm a')}
                        </Typography>
                        </Grid>
                        <Grid item md={12}>
                        <Typography variant="body2" color="textSecondary">
                            {event.location}
                        </Typography>
                        </Grid>
                    </Grid>
                </CardContent>
                <CardActions>
                    <Button size="small" onClick={() => handleRegister(event.id)}>Inscribirse</Button>
                </CardActions>
    </Card>
);
};

export default EventCard;